// Spanish translations
export default {
  translation: {
    cancel: 'Cancelar',
    'Special Names': 'Nombres Especiales',
    'Select an item from the list to edit its translations.': 'Selecciona un elemento de la lista para editar sus traducciones.',
    ' Nutrient values can also be edited here.': ' Los valores nutricionales también se pueden editar aquí.',
    'Nutrient Values': 'Valores Nutricionales',
    'No nutrients configured for this school.': 'No hay nutrientes configurados para esta escuela.',
    Tags: 'Etiquetas',
    'No Tags in this Dish': 'Sin Etiquetas en este Plato',
    usernameOrEmail: 'Nombre de usuario o correo electrónico',
    password: 'Contraseña',
    loggingIn: 'Iniciando sesión...',
    loginSuccess: '¡Inicio de sesión exitoso!',
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Añadir',
      saving: 'Guardando...',
      loading: 'Cargando...',
      loadingTranslations: 'Cargando traducciones...',
      retry: 'Reintentar',
      search: 'Buscar',
      saveSelectedTags: 'Guardar etiquetas seleccionadas',
      help: 'Ayuda'
    },
    admin: {
      saveChanges: 'Guardar Cambios',
      createNewDish: 'Crear Nuevo Plato',
      noMatchingDishes: 'No se encontraron platos coincidentes',
      createNewSpecialName: 'Crear Nuevo Nombre Especial',
      noMatchingSpecialNames: 'No se encontraron nombres especiales coincidentes',
      noSpecialNames: 'No hay nombres especiales disponibles',
      createSpecialName: 'Crear Nombre Especial',
      dish: 'Plato',
      recentMenus: 'Menús Recientes',
      month: 'Mes',
      actions: 'Acciones',
      editTranslations: 'Editar Traducciones',
      enterTranslation: 'Introducir Traducción',
      searchReplacement: 'Buscar reemplazo',
      loadingMenu: 'Cargando Menú',
      itemsToTranslate: 'Elementos a traducir',
      progress: 'Progreso',
      missingLanguages: 'Idiomas faltantes',
      skipItem: 'Omitir elemento',
      thisWillOnlyTakeAMoment: 'Esto solo tardará un momento',
      noMissingTranslations: 'No hay traducciones faltantes',
      allTranslationsComplete: 'Todas las traducciones están completas',
      noMenusFound: 'No se encontraron menús. Crea tu primer menú en el Editor de Menús.',
      noMatchingSpecialName: 'No se encontraron nombres especiales coincidentes',
      deleting: 'Eliminando...',
      copyWeek: {
        success: 'Semana copiada con éxito',
        errorProcessingResponse: 'Error al procesar la respuesta',
        errorInvalidMenuId: 'ID de menú no válido'
      },
      guidanceMenuCreation: {
        title: '¡Te damos la bienvenida al Editor de Menús!',
        description: 'Utiliza esta interfaz para crear menús mensuales. Luego puedes elegir mostrarlos semanal o mensualmente en la página de configuración. Haz clic en el botón crear en la parte superior izquierda de la pantalla para crear tu primer menú, y recuerda guardarlo cada vez que lo actualices o se perderán los cambios, haciendo clic en el botón de guardar que aparecerá en este mismo sitio. Una vez que tengas un menú creado, puedes previsualizarlo en la página de previsualización y ajustar cómo se mostrará a tu comunidad en la página de configuración. ¡Feliz gestión de menús!'
      },
      copyDay: {
        success: 'Día copiado con éxito',
        errorProcessingResponse: 'Error al procesar la respuesta',
        errorInvalidMenuId: 'ID de menú no válido'
      },
      preparingMenuEditor: 'Preparando el Editor de Menús...',
      saveTranslations: 'Guardar Traducciones',
      menuUpdated: 'Menú actualizado',
      menuCreated: 'Menú creado',
      menuDeleted: 'Menú eliminado',
      loading: 'Cargando...',
      noMenuTypesAvailable: 'No hay tipos de menú disponibles',
      preview: 'Vista previa',
      copy: 'Copiar',
      deleteMenu: 'Eliminar Menú',
      noCourses: 'No hay tipos de plato disponibles',
      noCoursesMessage: 'Debe crear tipos de plato antes de poder crear menús',
      specialDayPlaceholder: 'Nombre del día especial',
      noDishes: 'No hay platos disponibles',
      edit: 'Editar',
      delete: 'Eliminar',
      menuEditor: 'Editor de Menús',
      menuEditorDesc: 'Crear y gestionar menús escolares mensuales',
      translationEditor: 'Editor de Traducciones',
      translationEditorDesc: 'Gestionar traducciones para platos y otros elementos',
      translationQueue: 'Cola de Traducciones',
      translationQueueDesc: 'Traducir eficientemente múltiples elementos',
      nutrientQueue: 'Cola de Nutrientes',
      nutrientQueueDesc: 'Introducir información nutricional para platos',
      tagQueue: 'Cola de Etiquetas',
      tagQueueDesc: 'Gestionar eficientemente información de etiquetas para múltiples platos',
      settingsDesc: 'Gestionar configuraciones de la escuela, usuarios y configuraciones del sistema',
      useIntelligentSubstitution: 'Intentar sustitución inteligente de platos',
      intelligentSubstitutionTooltip: 'Utiliza datos históricos para hacer coincidir inteligentemente platos entre tipos de menú basándose en patrones de uso anteriores.',
      settings: 'Configuración',
      menuType: 'Tipo de Menú'
    },
    landing: {
      nav: {
        pricing: 'Precios'
      },
      features: {
        translation: {
          title: 'Traducciones Intuitivas',
          description: 'Traduce los elementos de tu menú a varios idiomas (EN, CA, ES incluidos por defecto) para servir a tu comunidad.'
        }
      }
    },
    pricing: {
      title: 'Precios',
      earlyAccessDescription: '¡Enhorabuena, eres una de las primeras personas en descubrir schoolmenus.xyz! Todavía estamos en desarrollo, lo que significa que los usuarios pueden encontrar algunos errores o problemas de rendimiento de vez en cuando (esperamos que todos sean menores).',
      freeUntilStable: 'Como agradecimiento por tu paciencia, schoolmenus.xyz será gratuito hasta que tengamos lista una primera versión estable. En ese momento, se introducirán planes de precios, pero los usuarios existentes serán recompensados con una suscripción gratuita de un año para que puedas seguir utilizando schoolmenus.xyz al menos durante el resto del curso escolar sin tener que preocuparte por empezar a pagar.'
    },
    monthNavigation: {
      title: 'Configuración de Navegación Pública',
      description: 'Permitir a los usuarios públicos navegar entre períodos (meses o semanas) en el visor de menús.',
      enable: 'Activar Navegación Pública',
      monthsBack: 'Períodos Anteriores Permitidos',
      monthsAhead: 'Períodos Futuros Permitidos',
      daysAfterStart: 'Días Permitidos para Retroceder (después del inicio del período)',
      daysBeforeEnd: 'Días Permitidos para Avanzar (antes del fin del período)',
      saveSettings: 'Guardar Configuración de Navegación',
      displayType: 'Tipo de Visualización',
      weekly: 'Semanal',
      monthly: 'Mensual',
      monthlyDescription: 'El menú público mostrará un mes completo a la vez.',
      weeklyDescription: 'El menú público mostrará una semana a la vez.',
      maxMonthsRange: 'Máximo {{max}} períodos',
      maxDaysRange: 'Máximo {{max}} días',
      invalidNumber: 'Por favor, introduzca un número válido',
      mustBePositive: 'El valor debe ser cero o positivo',
      tooManyMonths: 'El valor no puede exceder {{max}} períodos',
      tooManyDays: 'El valor no puede exceder {{max}} días'
    },
    settings: {
      title: 'Configuración',
      manageUsers: 'Gestionar Usuarios',
      users: 'Usuarios',
      menuTypes: 'Tipos de Menú',
      courses: 'Tipos de plato',
      nutrients: 'Nutrientes',
      schoolInfo: 'Información de la Escuela',
      webhooks: 'Webhooks',
      addUser: 'Añadir Usuario',
      editUser: 'Editar Usuario',
      deleteUser: 'Eliminar Usuario',
      userName: 'Nombre',
      userEmail: 'Correo Electrónico',
      userUsername: 'Nombre de Usuario',
      userRoles: 'Roles',
      userRole: 'Rol',
      userPassword: 'Contraseña',
      userSave: 'Guardar Usuario',
      confirmDeleteUser: '¿Está seguro de que desea eliminar este usuario?',
      userDeleted: 'Usuario eliminado correctamente',
      errorDeletingUser: 'Error al eliminar el usuario',
      userSaved: 'Usuario guardado correctamente',
      errorSavingUser: 'Error al guardar el usuario',
      edit: 'Editar',
      remove: 'Eliminar',
      delete: 'Eliminar',
      restrictedAccess: 'Acceso Restringido',
      inviteUser: 'Invitar Usuario',
      email: 'Correo Electrónico',
      enterEmail: 'Introducir correo electrónico',
      selectRoles: 'Seleccionar Roles',
      superadminOnly: 'Solo Superadministrador',
      viewer: 'Visualizador',
      editor: 'Editor',
      admin: 'Administrador',
      superadmin: 'Superadministrador',
      invite: 'Invitar',
      inviting: 'Invitando...',
      updateRoles: 'Actualizar Roles',
      errorSendingInvitation: 'Error al enviar invitación',
      userInvited: 'Usuario invitado correctamente',
      deleteConfirmation: 'Confirmar Eliminación',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando...',
      add: 'Añadir',
      translations: 'Traducciones',
      manageLanguages: 'Gestionar Idiomas',
      languages: 'Idiomas',
      saveChanges: 'Guardar Cambios',
      languagesExplanation: 'Seleccione los idiomas que desea utilizar en la aplicación.',
      defaultLanguage: 'Idioma Predeterminado',
      defaultLanguageExplanation: 'Este idioma se utilizará como fallback cuando una traducción no esté disponible.',
      selectDefaultLanguage: 'Seleccionar idioma predeterminado',
      availableLanguages: 'Idiomas Disponibles',
      translated: 'Traducido',
      noTranslation: 'Sin traducción',
      enterTranslation: 'Introducir traducción',
      requiredTranslation: 'Traducción obligatoria',
      defaultLanguageField: 'Campo del idioma predeterminado',
      usingFallbackTranslation: 'Usando traducción de respaldo',
      noTranslationsAvailable: 'No hay traducciones disponibles',
      
      // Nutrient related translations
      nutrientDisplaySettings: 'Configuración de Visualización de Nutrientes',
      nutritionalInformationExplanation: 'Elija si la información nutricional de cada menú diario debe mostrarse en el visor de menús. Si alguno de los platos del menú diario no tiene información nutricional, se mostrará un mensaje indicando que la información nutricional no está disponible.',
      showNutrients: 'Mostrar información nutricional en el visor de menús',
      noNutrientsYet: 'No se han creado nutrientes todavía.',
      addNewNutrient: 'Añadir Nuevo Nutriente',
      nutrientUnit: 'Unidad (g, mg, kcal...)',
      optionalUnitPlaceholder: 'Introducir unidad del nutriente',
      enabledNutrient: 'Mostrar este nutriente en el visor de menús',
      errorLoadingNutrients: 'Error al cargar los nutrientes. Por favor, inténtelo de nuevo más tarde.',
      disabled: 'Desactivado',
      
      // Tag related translations
      tagDisplaySettings: 'Configuración de Visualización de Etiquetas',
      tagExplanation: 'Cuando está activado, los iconos de etiquetas aparecerán debajo de los platos en el menú público con una leyenda que explica cada etiqueta.',
      existingTags: 'Etiquetas Existentes',
      editTag: 'Editar Etiqueta',
      showTags: 'Mostrar información de etiquetas en el menú público',
      tagTranslations: 'Traducciones',
      tagLogo: 'Logo de la Etiqueta',
      uploadLogoOptional: 'Subir logo (opcional)',
      currentFile: 'Archivo actual',
      clickOrDragToReplace: 'Haz clic o arrastra para reemplazar',
      clear: 'Eliminar',
      logoSizeRecommendation: 'Tamaño recomendado: 64x64px. Tamaño máximo: 2MB. Formatos admitidos: JPG, PNG, GIF, SVG, WebP',
      dragAndDrop: 'Arrastra y suelta tu archivo aquí o explora archivos',
      createNewTag: 'Crear Nueva Etiqueta',
      maxSize: 'Tamaño máximo: 2 MB',
      acceptedFileTypes: 'Tipos de archivo aceptados: .jpg, .jpeg, .png, .gif, .svg, .webp',
      createTag: 'Crear Etiqueta',
      noLogo: 'Sin logo',
      noTagsYet: 'No se han creado etiquetas todavía.',
      
      // Guidance messages
      guidanceCourses: {
        title: '¡Te damos la bienvenida a tu nueva escuela!',
        description: 'Tu primer paso es crear tipos de plato. Los tipos de plato representan diferentes partes de una comida (como "Primer plato", "Segundo plato", "Plato principal", "Guarnición", "Postre", etc.). Crea tipos de plato en la pestaña "Tipos de plato" a continuación.',
        examples: 'Ejemplos: Plato Principal, Ensalada, Sopa, Postre, Pan, Bebidas, Merienda'
      },
      guidanceMenuTypes: {
        title: '¡Genial! Ahora crea Tipos de Menú',
        description: 'Los Tipos de Menú representan diferentes tipos de menús que ofrece tu escuela (como "Almuerzo", "Desayuno", "Dieta Especial"). Crea tipos de menú en la pestaña "Tipos de Menú" y asígnales tipos de plato.',
        examples: 'Ejemplos: Almuerzo Estándar, Menú Vegetariano, Desayuno, Dieta Especial, Merienda',
        courses: 'Una vez que hayas creado tipos de menú, deberás asignarles tipos de plato haciendo clic en la flecha hacia abajo en la lista de tipos de menú.'
      },
      guidanceMenus: {
        title: '¡Perfecto! Ya estás listo para crear tu primer menú',
        description: 'Has creado correctamente tipos de plato y tipos de menú, y has asignado tipos de plato a los tipos de menú. Ahora puedes crear tu primer menú y comenzar a añadir platos para cada día.'
      },
      guidanceAction: {
        createCourses: 'Ir a la Pestaña de Tipos de Plato',
        createMenuTypes: 'Ir a la Pestaña de Tipos de Menú',
        createFirstMenu: 'Crear Tu Primer Menú'
      },
      
      // Menu Type related translations
      menuType: 'Tipo de Menú',
      menuTypeVisibility: 'Visibilidad del Tipo de Menú',
      showMenuTypePublicly: 'Mostrar este tipo de menú en el menú público',
      visibilityExplanation: 'Cuando está habilitado, este tipo de menú se mostrará en el visualizador de menú público',
      menuTypeOptions: 'Opciones de Visualización',
      showNutrientsForMenuType: 'Mostrar información nutricional para este tipo de menú',
      showTagsForMenuType: 'Mostrar información de etiquetas para este tipo de menú',
      nutrientTagExplanation: 'Estos ajustes controlan si la información de nutrientes y etiquetas se muestra para este tipo de menú, además de la configuración a nivel de escuela.',
      menuTypeSaved: 'Tipo de menú guardado correctamente',
      menuTypeDeleted: 'Tipo de menú eliminado correctamente',
      errorSavingMenuType: 'Error al guardar el tipo de menú',
      errorDeletingMenuType: 'Error al eliminar el tipo de menú',
      menuTypeInUseExplanation: 'Debe cambiar el tipo de menú en estos menús antes de poder eliminarlo',
      noNutrients: 'Sin Nutrientes',
      noTags: 'Sin Etiquetas',
      manageMenuTypes: 'Gestionar Tipos de Menú',
      addNewMenuType: 'Añadir Nuevo Tipo de Menú',
      deleteMenuTypeConfirmation: 'Eliminar Tipo de Menú',
      confirmDeleteMenuType: '¿Está seguro que desea eliminar el tipo de menú "{name}"?',
      cannotDeleteMenuTypeInUse: 'Este tipo de menú se utiliza en {count} menús y no se puede eliminar.',
      defaultMenuType: 'Tipo de Menú Predeterminado',
      defaultMenuTypeExplanation: 'El tipo de menú predeterminado se utilizará cuando se cree un nuevo menú',
      selectDefaultMenuType: 'Seleccione el tipo de menú predeterminado',
      updateDefaultMenuType: 'Actualizar Tipo de Menú Predeterminado',
      defaultMenuTypeUpdated: 'Tipo de menú predeterminado actualizado',
      errorUpdatingDefaultMenuType: 'Error al actualizar el tipo de menú predeterminado',
      noMenuTypesAvailable: 'No hay tipos de menú disponibles',
      hidden: 'Oculto',
      coursesForMenuType: 'Tipos de plato para este tipo de menú',
      loadingCourses: 'Cargando tipos de plato...',
      noCoursesForMenuType: 'No hay tipos de plato para este tipo de menú',
      confirmDelete: 'Confirmar Eliminación',
      
      // Course related translations
      manageCourses: 'Gestionar Tipos de Plato',
      addNewCourse: 'Añadir Nuevo Tipo de Plato',
      deleteCourseConfirmation: 'Eliminar Tipo de Plato',
      confirmDeleteCourse: '¿Está seguro que desea eliminar el tipo de plato "{name}"?',
      cannotDeleteCourseInUse: 'Este tipo de plato se utiliza en {count} elementos del menú y no se puede eliminar.',
      courseInUseExplanation: 'Debe eliminar o reemplazar este tipo de plato en todos los menús antes de poder eliminarlo.',
      noCourses: 'No hay tipos de plato disponibles',
      
      // School Information related translations
      schoolInformation: 'Información de la Escuela',
      basicInformation: 'Información Básica',
      schoolName: 'Nombre de la Escuela',
      subdomain: 'Subdominio',
      homepageUrl: 'URL de la Página Web',
      saveBasicInfo: 'Guardar Información Básica',
      schoolInfoSaved: 'Información de la escuela guardada correctamente',
      errorSavingSchoolInfo: 'Error al guardar la información de la escuela',
      checkingAvailability: 'Comprobando disponibilidad...',
      subdomainNotAvailable: 'Este subdominio no está disponible',
      subdomainChanged: 'Subdominio actualizado con éxito. Los cambios de DNS pueden tardar en propagarse.',
      subdomainCooldown: 'Período de Enfriamiento para Cambio de Subdominio',
      cooldownWillEndOn: 'Puede cambiar su subdominio nuevamente el {{date}} a las {{time}}.',
      subdomainChangeMessage: 'Su subdominio fue cambiado en los últimos 14 días. Puede cambiarlo nuevamente en 14 días.',
      customContent: 'Descripción de la Escuela',
      saveCustomContent: 'Guardar Descripción',
      customContentSaved: 'Descripción guardada correctamente',
      customContentPlaceholder: 'Introduce una descripción de tu escuela para mostrar en la página principal',
      errorSavingCustomContent: 'Error al guardar la descripción',
      disclaimerText: 'Disclaimer',
      disclaimerTextPlaceholder: 'Introduce disclaimer para las imágenes del menú...',
      saveDisclaimerText: 'Guardar Disclaimer',
      disclaimerTextSaved: 'Disclaimer guardado correctamente',
      errorSavingDisclaimerText: 'Error al guardar el disclaimer',
      includeCustomContentInImage: 'Incluir descripción en las imágenes del menú',
      includeCustomContentInImageExplanation: 'Controla si la descripción aparece en las imágenes con el menú diario descargado desde la página de previsualización de menús.',
      branding: 'Apariencia',
      schoolLogo: 'Logo de la Escuela',
      primaryBgColor: 'Color de Fondo Principal',
      primaryTextColor: 'Color de Texto Principal',
      secondaryBgColor: 'Color de Fondo Secundario',
      secondaryTextColor: 'Color de Texto Secundario',
      logoNote: 'Tamaño recomendado: 200x200px. Tamaño máximo: 2MB. Formatos aceptados: JPG, PNG, GIF, SVG.',
      saveBranding: 'Guardar Apariencia',
      
      // User roles and permissions
      roleExplanation: 'Permisos de Roles',
      superadminDesc: 'Acceso completo a esta escuela, puede asignar cualquier rol incluyendo admin y superadmin',
      adminDesc: 'Acceso completo a esta escuela, no puede asignar admin/superadmin ni eliminarlos',
      editorDesc: 'Puede editar menús y contenido pero no usuarios',
      viewerDesc: 'Acceso de solo lectura',
      noUsers: 'No se encontraron usuarios',
      errorFetchingUsers: 'Error al obtener usuarios',
      cannotRemoveAdmin: 'Solo los superadministradores pueden eliminar usuarios admin o superadmin',
      confirmRemoveUserTitle: 'Confirmar Eliminación de Usuario',
      confirmRemoveUserMessage: '¿Está seguro de que desea eliminar al usuario con correo {email} de esta escuela?',
      
      // Course management
      selectCourse: 'Seleccionar un tipo de plato',
      addCourseToMenuType: 'Añadir Tipo de plato al Tipo de Menú',
      noAvailableCourses: 'No hay tipos de plato disponibles para añadir',
      courseAddedToMenuType: 'Tipo de plato añadido al tipo de menú con éxito',
      courseRemovedFromMenuType: 'Tipo de plato eliminado del tipo de menú con éxito',
      errorAddingCourseToMenuType: 'Error al añadir el tipo de plato al tipo de menú',
      errorRemovingCourseFromMenuType: 'Error al eliminar el tipo de plato del tipo de menú',
      moveUp: 'Mover Arriba',
      moveDown: 'Mover Abajo',
      removeCourse: 'Eliminar tipo de plato',
      courseReordered: 'Tipo de plato reordenado con éxito',
      errorReorderingCourse: 'Error al reordenar el tipo de plato',
      
      // Language management
      noLanguagesSelected: 'No hay idiomas seleccionados',
      languageWarning: 'Nota: Deshabilitar un idioma lo ocultará del selector de idiomas, pero se conservarán las traducciones existentes.',
      defaultLanguageRequired: 'Se debe seleccionar un idioma predeterminado',
      defaultMustBeSelected: 'El idioma predeterminado debe estar incluido en los idiomas seleccionados',
      atLeastOneLanguage: 'Por favor, seleccione al menos un idioma',
      requiredLanguage: 'Idioma requerido',
      
      // Month Navigation Settings
      monthNavigation: {
        title: 'Configuración de Navegación Pública',
        description: 'Permitir a los usuarios públicos navegar entre períodos (meses o semanas) en el visor de menús.',
        enable: 'Activar Navegación Pública',
        monthsBack: 'Períodos Anteriores Permitidos',
        monthsAhead: 'Períodos Futuros Permitidos',
        daysAfterStart: 'Días Permitidos para Retroceder (después del inicio del período)',
        daysBeforeEnd: 'Días Permitidos para Avanzar (antes del fin del período)',
        saveSettings: 'Guardar Configuración de Navegación',
        displayType: 'Tipo de Visualización',
        weekly: 'Semanal',
        monthly: 'Mensual',
        monthlyDescription: 'El menú público mostrará un mes completo a la vez.',
        weeklyDescription: 'El menú público mostrará una semana a la vez.',
        maxMonthsRange: 'Máximo {{max}} períodos',
        maxDaysRange: 'Máximo {{max}} días',
        invalidNumber: 'Por favor, introduzca un número válido',
        mustBePositive: 'El valor debe ser cero o positivo',
        tooManyMonths: 'El valor no puede exceder {{max}} períodos',
        tooManyDays: 'El valor no puede exceder {{max}} días'
      },
      
      // Tags tab
      tags: 'Etiquetas',
      showTags: 'Mostrar Información de Etiquetas',

      // ADDED for SettingsPage specificity
      name: 'Nombre', // For user table header
      actions: 'Acciones', // For user table header
      delete: 'Eliminar' // For delete buttons in MenuType/Course lists
    },
    dishes: {
      add: 'Añadir Plato',
      edit: 'Editar Plato',
      name: 'Nombre',
      description: 'Descripción',
      type: 'Tipo',
      tags: 'Etiquetas',
      search: 'Buscar Platos',
      nextDay: 'Día siguiente',
      weekShort: 'Sem'
    },
    tags: {
      legend: 'Leyenda',
      saved: 'Etiquetas guardadas correctamente',
      saveError: 'Error al guardar las etiquetas',
      selectAtLeastOneOrConfirmNone: 'Seleccione al menos una etiqueta o confirme que no hay etiquetas',
      queueTitle: 'Cola de Etiquetas',
      loadError: 'Error al cargar las etiquetas',
      allDishesComplete: 'Todos los platos tienen la información de etiquetas completa',
      dishes: 'Platos',
      noSearchResults: 'No se encontraron resultados para la búsqueda',
      noDishesNeedTags: 'No hay platos que necesiten información de etiquetas',
      unsavedChanges: 'Tiene cambios sin guardar',
      pendingChanges: 'Cambios pendientes',
      assignFor: 'Asignar etiquetas para',
      confirmNoTags: 'Confirmar sin etiquetas',
      selectTags: 'Seleccionar etiquetas',
      noTagsConfigured: 'No hay etiquetas configuradas',
      noTranslation: 'Sin traducción',
      selectDish: 'Seleccione un plato',
      displaySettings: 'Configuración de Visualización de Etiquetas',
      showInMenu: 'Mostrar información de etiquetas en el menú público',
      showInMenuHelp: 'Cuando está activado, los iconos de etiquetas aparecerán debajo de los platos en el menú público con una leyenda que explica cada etiqueta.',
      existing: 'Etiquetas Existentes',
      createNew: 'Crear Nueva Etiqueta',
      logo: 'Logo de la Etiqueta',
      uploadLogo: 'Subir logo (opcional)',
      logoRequirements: 'Tamaño recomendado: 64x64px. Tamaño máximo: 2MB. Formatos admitidos: JPG, PNG, GIF, SVG, WebP',
      create: 'Crear Etiqueta',
      creating: 'Creando...',
      loading: 'Cargando etiquetas...',
      notConfiguredWarning: 'No hay etiquetas configuradas. Agregue etiquetas en la página de Configuración primero.',
      noTagsInDish: 'No hay etiquetas en este plato',
      defaultLanguageRequired: 'Se requiere traducción en el idioma predeterminado',
      translationRequired: 'Se requiere al menos una traducción',
      fetchError: 'Error al cargar etiquetas',
      createSuccess: 'Etiqueta creada correctamente',
      createError: 'Error al crear etiqueta',
      updateSuccess: 'Etiqueta actualizada correctamente',
      updateError: 'Error al actualizar etiqueta',
      deleteSuccess: 'Etiqueta eliminada correctamente',
      deleteError: 'Error al eliminar etiqueta',
      settingUpdateSuccess: 'Configuración de visualización de etiquetas actualizada',
      settingUpdateError: 'Error al actualizar la configuración de visualización de etiquetas'
    },
    modal: {
      delete: 'Eliminar'
    },
    languageNames: {
      en: 'Inglés',
      ca: 'Catalán',
      es: 'Español',
      fr: 'Francés'
    },
    general: {
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Añadir',
      close: 'Cerrar',
      accept: 'Aceptar',
      create: 'Crear'
    },
    queue: {
      individualInput: 'Entrada Individual',
      bulkImportExport: 'Importación/Exportación Masiva',
      editNutrientsFor: 'Editar Nutrientes Para',
      missingNutrients: 'Nutrientes Faltantes',
      dishesMissingNutrients: 'Platos Sin Nutrientes',
      enterValue: 'Introducir valor',
      skipItem: 'Omitir Elemento',
      deleteDish: 'Eliminar Plato',
      saveAndNext: 'Guardar y Siguiente',
      missing: 'faltantes',
      nutrientValuesSaved: '¡Valores nutricionales guardados correctamente!',
      errorSavingNutrients: 'Error al guardar valores nutricionales',
      selectDishToEnterNutrients: 'Seleccione un plato de la lista para introducir valores nutricionales',
      nutrientQueueCompleteMessage: 'Todos los platos tienen valores nutricionales introducidos.',
      nutrientQueueCompleteTitle: '¡Cola de Nutrientes Completa!',
      errorLoadingNutrientQueue: 'Error al cargar la cola de nutrientes.'
    },
    copyWeek: {
      title: 'Copiar Semana',
      targetMenuType: 'Tipo de Menú Destino',
      targetMonth: 'Mes Destino',
      targetWeek: 'Semana Destino',
      selectMenuType: 'Seleccionar Tipo de Menú',
      selectWeek: 'Seleccionar Semana',
      daysInTargetMonth: 'Días en el mes destino:',
      weekLabel: 'Semana {{weekNumber}}: {{dateRange}}',
      copy: 'Copiar',
      confirmOverwrite: 'Confirmar Sobrescritura',
      confirmOverwriteMessage: 'Ya existe un menú para el mes y tipo de menú seleccionados. ¿Desea sobrescribir los elementos del menú para los días seleccionados?'
    },
    copyDay: {
      title: 'Copiar Día',
      targetMenuType: 'Tipo de Menú Destino',
      targetMonth: 'Mes Destino',
      targetDay: 'Día Destino',
      targetDays: 'Días Destino',
      selectMenuType: 'Seleccionar Tipo de Menú',
      selectDay: 'Seleccionar Día',
      selectMultipleDays: 'Seleccione uno o más días',
      selectedDay: 'Día seleccionado:',
      selectedDays: 'Días seleccionados:',
      sourceDay: 'Día origen:',
      copy: 'Copiar',
      confirmOverwrite: 'Confirmar Sobrescritura',
      confirmOverwriteMessage: 'Ya existe un menú para el mes y tipo de menú seleccionados. ¿Desea sobrescribir los elementos del menú para el día seleccionado?',
      confirmOverwriteMultipleMessage: 'Ya existe un menú para el mes y tipo de menú seleccionados. ¿Desea sobrescribir los elementos del menú para los {{count}} días seleccionados?',
      success: 'Día copiado con éxito',
      multiSuccess: 'Días copiados con éxito',
      errorProcessingResponse: 'Error al procesar la respuesta',
      errorInvalidMenuId: 'ID de menú no válido'
    },
    errors: {
      selectWeekFirst: 'Por favor, seleccione una semana primero',
      selectDayFirst: 'Por favor, seleccione un día primero',
      selectDaysFirst: 'Por favor, seleccione al menos un día primero',
      failedToLoadMenuTypes: 'No se pudieron cargar los tipos de menú',
      failedToCopyWeek: 'Error al copiar la semana',
      failedToCopyDay: 'Error al copiar el día/los días',
      subdomain_change_failed: 'Error al cambiar el subdominio'
    },
    // Direct top-level keys (no namespaces)
    loadingRoles: 'Cargando roles...',
    Dishes: 'Platos',
    Dish: 'Plato',
    'Special Name': 'Nombre Especial',
    'Search...': 'Buscar...',
    'Add New Dish': 'Añadir Nuevo Plato',
    'Creating...': 'Creando...',
    'Create Dish': 'Crear Plato',
    'Translations': 'Traducciones',

    // Admin Dashboard translations
    'Admin Dashboard': 'Panel de Administración',
    'Menu Editor': 'Editor de Menús',
    'Create and manage monthly school menus': 'Crear y gestionar menús escolares mensuales',
    'Translation Editor': 'Editor de Traducciones',
    'Manage translations for dishes and other items': 'Gestionar traducciones de platos y otros elementos',
    'Translation Queue': 'Cola de Traducciones',
    'Efficiently translate multiple items': 'Traducir eficientemente múltiples elementos',
    'Tag Queue': 'Cola de Etiquetas',
    'Efficiently manage tag information for multiple dishes': 'Gestionar eficientemente información de etiquetas para múltiples platos',
    'Settings': 'Configuración',
    'Manage school settings, users, and system configurations': 'Gestionar configuraciones de la escuela, usuarios y configuraciones del sistema',

    // ONLY keeping namespaces that are actually used as namespaces
    auth: {
      pleaseLogin: 'Por favor, inicie sesión'
    },
    menu: {
      // Converting to Spanish translations instead of placeholders
      noMenuForType: 'No hay menú para este tipo',
      noMenusAvailable: 'No hay menús disponibles',
      schoolLunchMenu: 'Menú de Comida Escolar',
      menuType: 'Tipo de Menú',
      notAvailable: 'No disponible',
      noMenu: 'No hay menú',
      footer: 'El menú está sujeto a cambios según la disponibilidad de ingredientes',
      dishNotTranslated: 'Plato no traducido',
      previousWeek: 'Semana anterior',
      previousMonth: 'Mes anterior',
      nextWeek: 'Semana siguiente',
      nextMonth: 'Mes siguiente',
      selectDay: 'Seleccionar día',
      checkingAvailableMenus: 'Comprobando menús disponibles',
      removeFromFavorites: 'Eliminar de favoritos',
      addToFavorites: 'Añadir a favoritos',
      favorites: 'Favoritos',
      previousFavorites: 'Favoritos anteriores',
      selectMenuType: 'Seleccionar tipo de menú',
      nextFavorites: 'Siguientes favoritos',
      nutrientDataComplete: 'Datos nutricionales completos',
      nutrientDataIncomplete: 'Datos nutricionales no disponibles',
      noDataForDay: 'No hay datos para este día',
      previousDay: 'Día anterior',
      nextDay: 'Día siguiente',
      weekShort: 'Sem'
    },
    forgottenPassword: {
      emailRequired: 'El correo electrónico es obligatorio',
      error: 'Error',
      serverError: 'Error del servidor',
      title: 'Recuperar contraseña',
      instruction: 'Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña',
      email: 'Correo electrónico',
      submitting: 'Enviando...',
      submit: 'Enviar',
      emailSent: 'Se ha enviado un correo electrónico con instrucciones',
      backToLogin: 'Volver a Iniciar sesión'
    },
    translations: {
      fileEmpty: 'El archivo está vacío o tiene un formato no válido',
      noLanguageColumns: 'No se encontraron columnas de idioma en el archivo',
      duplicateTranslations: 'El archivo contiene traducciones duplicadas. Cada traducción debe ser única para cada idioma.',
      badRequestHelp: 'Solicitud no válida. Verifique el formato del archivo y vuelva a intentarlo.',
      validationError: 'Error de validación',
      validationErrorDetails: 'Detalles del error de validación',
      wrongFileFormat: 'Formato de archivo incorrecto',
      fileStructureExample: 'Ejemplo de estructura de archivo',
      tryExportFirst: 'Intente exportar primero para ver el formato correcto',
      duplicateHelp1: 'El archivo contiene elementos duplicados',
      duplicateHelp2: 'Cada elemento debe tener un ID único',
      duplicateHelp3: 'Corrija los duplicados y vuelva a intentarlo',
      selectLanguagesFirst: 'Seleccione los idiomas primero',
      exportError: 'Error al exportar',
      importError: 'Error al importar',
      bulkTranslations: 'Traducciones Masivas',
      individualTranslations: 'Traducciones Individuales',
      step1: 'Paso 1: Exportar',
      exportDescription: 'Exporte traducciones existentes para editar',
      exportButton: 'Exportar',
      exportAllButton: 'Exportar Todo',
      step2: 'Paso 2: Subir',
      uploadDescription: 'Suba archivo XLSX con traducciones',
      selectFile: 'Seleccionar Archivo',
      step3: 'Paso 3: Validar e Importar',
      validateDescription: 'Valide el archivo antes de importar',
      validateButton: 'Validar',
      importSuccess: 'Importación exitosa',
      changesDetected: 'Se detectaron cambios',
      noChangesDetected: 'No se detectaron cambios',
      validationSummaryTitle: 'Resumen de Validación',
      confirmImport: 'Confirmar Importación',
      importing: 'Importando...',
      importCompleteTitle: 'Importación Completa',
      itemsProcessed: 'Elementos procesados',
      translationsCreated: 'Traducciones creadas',
      translationsUpdated: 'Traducciones actualizadas',
      totalItems: 'Total de elementos',
      totalTranslations: 'Total de traducciones',
      toBeCreated: 'A crear',
      toBeUpdated: 'A actualizar',
      errorsFound: '{{count}} Error(es) encontrado(s)',
      showErrorsLink: 'Mostrar errores',
      showDetailsLink: 'Mostrar detalles',
      hideDetailsLink: 'Ocultar detalles',
      itemTypeHeader: 'Tipo de elemento',
      itemNameHeader: 'Nombre del elemento',
      languageHeader: 'Idioma',
      originalValueHeader: 'Valor original',
      newValueHeader: 'Valor nuevo',
      errorHeader: 'Error',
      changedTranslationsHeading: 'Traducciones cambiadas',
      unchangedTranslationsHeading: 'Traducciones sin cambios',
      newItemsHeading: 'Elementos nuevos',
      itemsWithErrorsHeading: 'Elementos con errores',
      noItemsInSection: 'No hay elementos en esta sección'
    },
    navbar: {
      confirmNavigation: '¿Estás seguro de que quieres salir? Los cambios no guardados se perderán.',
      unsavedChanges: 'Tienes cambios sin guardar',
      home: 'Inicio',
      menu: 'Menú',
      admin: 'Administración',
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      settings: 'Configuración',
      createMenu: 'Crear Menú',
      dishLibrary: 'Biblioteca de Platos',
      translations: 'Traducciones',
      specialNames: 'Nombres de Días Especiales',
      dashboard: 'Panel',
      leave: 'Salir',
      cancel: 'Cancelar',
      schoolHomepage: 'Página de Inicio de la Escuela'
    },
    fileUploader: {
      dragDrop: 'Arrastra y suelta tu archivo aquí',
      or: 'o',
      browse: 'explorar archivos',
      acceptedTypes: 'Tipos de archivo aceptados',
      maxSize: 'Tamaño máximo',
      fileSelected: 'Archivo seleccionado, haz clic o arrastra para reemplazar',
      clear: 'Eliminar',
      currentFile: 'Archivo actual',
      clickToReplace: 'Haz clic o arrastra para reemplazar',
      fileError: 'Hubo un error con el archivo',
      invalidType: 'Tipo de archivo no válido',
      tooLarge: 'El archivo es demasiado grande',
      recommendedSize: 'Tamaño recomendado',
      dragAndDrop: 'Arrastra y suelta tu archivo aquí o explora archivos'
    },
    welcome: 'Menú Escolar',
    dashboard: 'Panel',
    logout: 'Cerrar Sesión',
    adminDashboard: 'Panel de Administración',
    viewPublicSite: 'Ver Sitio Público',
    allSchools: 'Todas las Escuelas',
    profile: 'Perfil',
    profilePage: {
      title: 'Mi Perfil',
      name: 'Nombre',
      username: 'Nombre de Usuario',
      email: 'Correo Electrónico',
      nameRequired: 'El nombre es obligatorio',
      usernameRequired: 'El nombre de usuario es obligatorio',
      usernameInvalid: 'El nombre de usuario solo puede contener letras, números y guiones bajos',
      usernameHint: 'Use solo letras, números y guiones bajos',
      emailRequired: 'El correo electrónico es obligatorio',
      emailInvalid: 'El correo electrónico no es válido',
      emailInUse: 'El correo electrónico ya está en uso',
      usernameInUse: 'El nombre de usuario ya está en uso',
      saveChanges: 'Guardar Cambios',
      saving: 'Guardando...',
      checking: 'Verificando...',
      updateSuccess: 'Perfil actualizado correctamente',
      updateFailed: 'Error al actualizar el perfil',
      changePassword: 'Cambiar Contraseña',
      changePasswordButton: 'Cambiar Contraseña',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Nueva Contraseña',
      currentPasswordRequired: 'La contraseña actual es obligatoria',
      newPasswordRequired: 'La nueva contraseña es obligatoria',
      passwordTooShort: 'La contraseña debe tener al menos 12 caracteres',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      incorrectPassword: 'La contraseña actual es incorrecta',
      passwordChangeSuccess: 'Contraseña cambiada correctamente',
      passwordChangeFailed: 'Error al cambiar la contraseña',
      passwordRequirements: 'Mínimo 12 caracteres',
      updatePassword: 'Actualizar Contraseña',
      changing: 'Cambiando...',
      cancel: 'Cancelar'
    },
    calendar: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre'
    },
    home: {
      welcome: 'Te damos la bienvenida a la Aplicación de Menú Escolar',
      viewMenu: 'Ver Menú',
      aboutSchool: 'Sobre Nuestra Escuela',
      contactUs: 'Contáctenos'
    },
    login: 'Iniciar Sesión',
    loginPage: {
      email: 'Correo Electrónico',
      password: 'Contraseña',
      loginButton: 'Iniciar Sesión',
      loginError: 'Correo electrónico o contraseña inválidos',
      forgotPassword: '¿Olvidó su Contraseña?'
    },
    pagination: {
      showing: 'Mostrando',
      to: 'a',
      of: 'de',
      results: 'resultados',
      previous: 'Anterior',
      next: 'Siguiente'
    },
    upload: {
      fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es {{maxSize}}MB.',
      invalidFileType: 'Tipo de archivo no válido. Por favor, suba un archivo de imagen.',
      errorReadingFile: 'Error al leer el archivo. Por favor, inténtelo de nuevo.',
      dragAndDrop: 'Arrastre y suelte el archivo aquí',
      or: 'o',
      browse: 'explorar archivos',
      maxSizeNote: 'Tamaño máximo: {{maxSize}}MB',
      acceptedFormatsNote: 'Formatos aceptados'
    },
    nutrientutils: {
      nutrients: 'Nutrientes',
      nutrientDisplaySettings: 'Configuración de Visualización de Nutrientes',
      nutritionalInformationExplanation: 'Elija si la información nutricional de cada menú diario debe mostrarse en el visor de menús. Si alguno de los platos del menú diario no tiene información nutricional, se mostrará un mensaje indicando que la información nutricional no está disponible.',
      showNutrients: 'Mostrar información nutricional en el visor de menús',
      addNewNutrient: 'Añadir Nuevo Nutriente',
      errorLoadingNutrients: 'Error al cargar los nutrientes. Por favor, inténtelo de nuevo más tarde.',
      noNutrientsYet: 'No se han creado nutrientes todavía.',
      disabled: 'Oculto',
      enabledNutrient: 'Mostrar este nutriente en el visor de menús',
      editNutrient: 'Editar Nutriente',
      deleteNutrient: 'Eliminar Nutriente',
      deleteNutrientConfirmation: '¿Está seguro de que desea eliminar este nutriente? Esta acción no se puede deshacer.',
      nutrientUpdated: 'Nutriente actualizado correctamente',
      errorUpdatingNutrient: 'Error al actualizar nutriente.',
      nutrientDeleted: 'Nutriente eliminado correctamente',
      errorDeletingNutrient: 'Error al eliminar nutriente.'
    },
    loginToSchool: 'Iniciar sesión en {{schoolName}}',
    loginToAccount: 'Iniciar sesión en su cuenta',
    mainDomainLoginDescription: 'Inicie sesión para acceder a todas sus escuelas',
    schoolSelectorTitle: 'Sus Escuelas',
    schoolSelectorDescription: 'Seleccione una escuela para gestionar sus menús y configuraciones',
    createNewSchool: 'Crear Nueva Escuela',
    accessAdmin: 'Acceder a Administración',
    noSchoolsFound: 'Aún no tiene acceso a ninguna escuela.',
    deleteSchool: 'Eliminar Escuela',
    deleteSchoolConfirmation: '¿Está seguro de que desea eliminar',
    deleteSchoolWarning: 'Esta acción no se puede deshacer.',
    deleting: 'Eliminando...',
    creating: 'Creando...',
    createSchool: 'Crear Escuela',
    schoolName: 'Nombre de la Escuela',
    subdomain: 'Subdominio',
    homepageUrl: 'URL del Sitio Web Escolar',
    subdomainHelp: 'Solo letras minúsculas, números y guiones'
  }
};